/* eslint-disable no-unused-vars */
import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from 'react';
import { StyleSheet, createElement } from 'react-native';

function WebViews(props, ref) {
  const {
    title,
    scrollEnabled = true,
    source,
    style,
    onLoad,
    onMessage,
  } = props;

  const [html, setHtml] = useState('');
  const [iframe, setIframe] = useState('');

  const handleSource = (source) => {
    if (!source.method) {
      return;
    }
    handleSourceInIFrame(source);
  };

  const handleSourceInIFrame = (source) => {
    const { uri, ...options } = source;
    const baseUrl = uri.substr(0, uri.lastIndexOf('/') + 1);
    // eslint-disable-next-line no-undef
    fetch(uri, options)
      .then((response) => response.text())
      .then((html) => setHtml(`<base href="${baseUrl}" />` + html));
  };

  const onMessages = (nativeEvent) => onMessage(nativeEvent);

  useImperativeHandle(ref, () => ({
    injectJavaScript(code) {
      if (source.html) {
        setHtml(
          source.html.replace('</script></body>', `${code}</script></body>`),
        );
      }
    },
  }));

  useEffect(() => {
    let mounted = false;
    if (iframe && !mounted) {
      const elm = iframe.contentWindow;
      elm.addEventListener('message', onMessages, true);
      return () => {
        elm.removeEventListener('message', onMessages, true);
        mounted = true;
      };
    }
    return () => {
      mounted = true;
    };
  }, [iframe]);

  useEffect(() => {
    async function fetchSource() {
      await handleSource(source);
    }
    fetchSource();
  }, []);

  return createElement('iframe', {
    title,
    ref: (node) => setIframe(node),
    src: !source.method ? source.uri : undefined,
    srcDoc: html || source.html,
    width: style && style.width,
    height: style && style.height,
    style: StyleSheet.flatten([
      styles.iframe,
      scrollEnabled && styles.noScroll,
      style,
    ]),
    allowFullScreen: true,
    allowpaymentrequest: 'true',
    frameBorder: '0',
    seamless: true,
    onLoad,
  });
}

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  iframe: {
    width: '100%',
    height: '100%',
    borderWidth: 0,
  },
  noScroll: {
    overflow: 'hidden',
  },
});

export default forwardRef(WebViews);
